export function isPrerender() {
	return typeof window === 'undefined';
}